<template>
  <aia-container>
    <div class="aia-add-phone" slot="login">
      <el-form
        class="login-form form-custom clearfix"
        ref="form"
        label-position="top"
        label-width="80px"
        @submit.native.prevent
        :hide-required-asterisk="true"
        :rules="rules"
        :model="form"
      >
        <!-- 手机号码 -->
        <el-form-item class="form-item-primary" prop="aia_extra_phone">
          <BaseInput
            v-model="form.aia_extra_phone"
            :tabIndexNum="'3'"
            :validate-event="Boolean(form.aia_extra_phone)"
            :placeholer="$t('login.register.enterYourPhone')"
            :maxLength="11"
          >
          </BaseInput>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item class="form-item-primary" prop="aia_extra_phone_code">
          <BaseInput
            v-model.trim="form.aia_extra_phone_code"
            :maxlength="smsLength"
            :validate-event="Boolean(form.aia_extra_phone_code)"
            :placeholer="$t('login.register.labelCode')"
            :tabIndexNum="'4'"
            @focus="changeCode"
          >
            <template #btn>
              <VerificationCode
                ref="verification"
                @click="sendCode"
                :account="form.aia_extra_phone"
                :from="'register'"
                :isActive="activeSms"
              />
            </template>
            <template #prefix>
              {{ $t('login.register.verificationCode') }}
            </template>
          </BaseInput>
        </el-form-item>
      </el-form>
      <el-button
        class="button-custom aia-button-custom aia-phone-button"
        @click="handleSubmit"
      >
        提 交
      </el-button>
    </div>
  </aia-container>
</template>

<script>
import AiaContainer from './components/AiaContainer'
import store from '@/store'
import { isNeedHandleSMSActive } from '@/utils/consts'
import BaseMixin from '@/mixins/BaseMixin'
import VerificationCode from '@/components/login/VerificationCode.vue'
import _throttle from 'lodash/throttle'
import { getBusinessType } from '@/constant'
import { handleLogin } from '@/utils/mutiple.js'
import { setItem } from '@/utils/storage-main.js'

const AiaConfig = getBusinessType()
const AIA_ID = AiaConfig.id

export default {
  mixins: [BaseMixin],
  components: {
    AiaContainer,
    VerificationCode,
  },
  data() {
    return {
      form: {
        aia_extra_phone: '',
        aia_extra_phone_code: '',
      },
      isWrong: false,
    }
  },
  methods: {
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      this.$refs['form'].validateField('aia_extra_phone', (vaild) => {
        if (!vaild) {
          if (isNeedHandleSMSActive()) {
            this.$store.commit('SET_SMSISACTIVE', false)
          }
          this.$refs['verification'].send()
        }
      })
    },
    handleSubmit: _throttle(
      function () {
        this.$refs['form'].validate((valid) => {
          if (!valid) return

          this.$gotinTrack.standaloneSendData({ name: `agentlogin.confirm` })
          this.toSubmit()
        })
      },
      500,
      { trailing: false }
    ),
    async toSubmit() {
      const res = await this.$store.dispatch('setSaveExtraInfo', {
        source: AIA_ID,
        prop: {
          aia_action: '2',
          ...this.form,
        },
      })
      if (res?.data.state == 'success') {
        setItem('aiaLogined', true)
        handleLogin(AIA_ID)
        return
      }
    },
  },
  computed: {
    rules() {
      return {
        aia_extra_phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
            trigger: 'blur',
          },
        ],
        aia_extra_phone_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
    smsLength() {
      return store.state.smsLength
    },
    activeSms() {
      return store.state.activeSms
    },
  },
}
</script>
<style lang="scss">
.aia-add-phone {
  background: rgba(215, 229, 245, 0.9);
  border-radius: 6px;
  width: calc(100% - 66px);
  padding: 34px 26px;
  box-sizing: border-box;

  .aia-add-phone-title {
    color: rgba(61, 77, 104, 1);
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 29px;
  }

  .aia-add-phone-tip {
    font-size: 16px;
    color: rgba(68, 88, 123, 0.8);
    margin-bottom: 29px;
  }
  .aia-phone-button {
    margin-top: 24px;
  }
}
</style>
